/**
 * Sample words — first-run Generate-view starter chips (issue #7).
 *
 * Keyed by TARGET language: a brand-new user taps a word in the language
 * they're learning and gets a first card in one tap (the u2 pattern — an
 * en-ko user typed the English word "charcoal"). buildProfile() resolves
 * this table per directional profile; unknown/missing languages fall back
 * to the en table.
 *
 * Selection criteria: short, everyday, image-friendly (concrete words the
 * generator reliably turns into rich cards). Keep 2-3 per language — the
 * chips render only for 0-card users with an empty compose.
 */

const EN_FALLBACK: readonly string[] = ['charcoal', 'serendipity', 'firefly']

const SAMPLE_WORDS: Record<string, readonly string[]> = {
  en: EN_FALLBACK,
  ko: ['가을', '바다', '고양이'], // autumn, sea, cat
  ja: ['紅葉', '桜', '星空'], // autumn leaves, cherry blossom, starry sky
  zh: ['长城', '月饼', '熊猫'], // Great Wall, mooncake, panda
  'zh-hant': ['夜市', '颱風', '熊貓'], // night market, typhoon, panda
  es: ['madrugada', 'sobremesa', 'churro'],
  fr: ['flâner', 'brioche', 'sablier'], // to stroll, brioche, hourglass
  de: ['Fernweh', 'Bratwurst', 'Gletscher'], // wanderlust, bratwurst, glacier
}

/** Starter words for a target language; unknown codes fall back to en. */
export function sampleWordsFor(lang: string): readonly string[] {
  return SAMPLE_WORDS[lang] ?? EN_FALLBACK
}
